import { Button, Pagination, Table } from "react-bootstrap";
import React from "react";
import styles from "./TableDesign.module.css";
import SortIcon from "../../../assets/images/sort-icon.svg";
import Loader from "../loader/Loader";
import { useEffect } from "react";

const TableDesign = ({
  tableHeadings,
  filterHandler = () => {},
  pagination = null,
  isLoader = false,
  button = null,
  filterOption = null,
  setFilterOption = () => {},
  filterSection = null,
  ...props
}) => {
  const { title = "", children } = props;

  const paginationContainer = () => {
    const currentPage = pagination?.currentPage;
    const totalPages = pagination?.totalPages;

    const pageNumbers = [];

    // If there are 5 or fewer pages, show all page numbers without ellipsis
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // For more than 5 pages, use ellipsis logic
      pageNumbers.push(1); // Always show the first page

      if (currentPage > 3) {
        pageNumbers.push("ellipsis");
      }

      // Show pages around the current page
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        if (!pageNumbers.includes(i)) {
          pageNumbers.push(i);
        }
      }

      if (currentPage < totalPages - 2) {
        pageNumbers.push("ellipsis");
      }

      if (!pageNumbers.includes(totalPages)) {
        pageNumbers.push(totalPages); // Always show the last page
      }
    }

    const uniquePageNumbers = pageNumbers;

    return (
      <Pagination className={styles.pagination}>
        <Pagination.First style={{fontSize:'14px'}}
          onClick={(e) => {
            e.preventDefault();
            setFilterOption({
              ...filterOption,
              page: 1,
            });
          }}
          // active={currentPage === 1}
        />

        <Pagination.Prev style={{fontSize:'14px'}}
          disabled={!pagination?.hasPreviousPage && "disabled"}
          onClick={(e) => {
            e.preventDefault();
            setFilterOption({
              ...filterOption,
              page: currentPage - 1,
            });
          }}
        />

        {uniquePageNumbers.map((pageNumber, index) => (
          <React.Fragment key={index}>
            {pageNumber === "ellipsis" ? (
              <Pagination.Ellipsis />
            ) : pageNumber === 1 || pageNumber === totalPages  ? (
              <Pagination.Item
                onClick={(e) => {
                  e.preventDefault();
                  setFilterOption({
                    ...filterOption,
                    page: pageNumber,
                  });
                }}
                active={currentPage === pageNumber}
              >
                {pageNumber}
              </Pagination.Item>
            ) : (

              <Pagination.Item
                onClick={(e) => {
                  e.preventDefault();
                  setFilterOption({
                    ...filterOption,
                    page: pageNumber,
                  });
                }}
                active={currentPage === pageNumber}
              >
                {pageNumber}
              </Pagination.Item>
            )}
          </React.Fragment>
        ))}

        <Pagination.Next
          disabled={!pagination?.hasNextPage && "disabled"}
          onClick={(e) => {
            e.preventDefault();
            setFilterOption({
              ...filterOption,
              page: currentPage + 1,
            });
          }}
        />
        <Pagination.Last
          onClick={(e) => {
            e.preventDefault();
            setFilterOption({
              ...filterOption,
              page: totalPages,
            });
          }}
          // active={currentPage === totalPages}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    );
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableContent}>
        {button && (
          <Button
          className="btn-primary"
          onClick={() => button?.action()}
          style={{ float: "right", marginTop: "8px" }}
          >
            {button?.label}
          </Button>
        )}
        {title && <h2>{title}</h2>}
        {filterSection && <div style={{display:'flex',right:'0px',justifyContent:'flex-end',alignItems:'center',marginTop:'-60px',marginBottom:'10px'}}>
        {filterSection}
        </div>}
      </div>
      <Table responsive>
        <thead>
          <tr>
            {tableHeadings.map((heading, i) => (
              <th
                key={i}
                className={
                  heading?.align
                    ? heading?.align
                    : "left" && heading?.whiteSpace
                    ? heading?.whiteSpace
                    : "nowrap"
                }
                width={heading?.width ? heading?.width : ""}
                whiteSpace={
                  heading?.whiteSpace ? heading?.whiteSpace : "nowrap"
                }
                onClick={(e) => {
                  e.preventDefault();
                  if (heading?.sort) {
                    setFilterOption({
                      ...filterOption,
                      orderBy: heading?.sort,
                      orderIn: filterOption?.orderIn === 1 ? -1 : 1,
                    });
                    e.target.parentElement.childNodes.forEach((n) =>
                      n.classList.remove("active")
                    );
                    e.target.classList.add("active");
                  }
                }}
              >
                {heading.label}
                {heading?.sort && <img src={SortIcon} alt="Sort Record" />}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </Table>

      {pagination && paginationContainer()}
    </div>
  );
};

export default TableDesign;
